<template>
  <main class="rh-development">
    <rh-cabecalho
      pagina="desenvolvimento"
      subtitulo="DESENVOLVIMENTO"
      titulo=""
      descricao=""
      :unidade-id="unidadeId"
      :empresas="empresas"
      :mostrar-pessoas="podeGerir"
      :mostrar-configuracao="isInRole('rh-diretoria')"
      @empresa-selecionada="selecionarEmpresa"
    />
    <b-message v-if="erro" type="is-danger" aria-close-label="Fechar" @close="erro = ''">{{ erro }}</b-message>
    <b-loading :active="loading" :is-full-page="false"></b-loading>
    <section v-if="meusCursos.length>0" class="rh-card rh-learning-card">
      <div class="rh-card-head">
        <div><p class="rh-kicker">MINHA APRENDIZAGEM</p><h2>Meus Cursos</h2><p class="rh-muted"></p></div>        
      </div>
      <b-table :data="meusCursos" paginated :per-page="5" hoverable mobile-cards>
        <b-table-column v-slot="p" field="nome" label="Curso" sortable><strong>{{ p.row.nome }}</strong></b-table-column>
        <b-table-column v-slot="p" field="cargaHorariaMinutos" label="Carga Horária">{{ duracaoCurso(p.row.cargaHorariaMinutos) }}</b-table-column>
        <b-table-column v-slot="p" field="status" label="Status"><b-tag :type="p.row.status === 'CONCLUIDO' ? 'is-success' : 'is-info'">{{ statusCurso(p.row.status) }}</b-tag></b-table-column>
        <b-table-column v-slot="p" label="Ações" width="140"><b-button size="is-small" type="is-primary" icon-right="arrow-right" :aria-label="`Abrir meus cursos: ${p.row.nome}`" @click="irParaCursos('ead-meus-cursos')">Acessar</b-button></b-table-column>
      </b-table>
    </section>
    <section class="rh-card rh-team-select">
      <b-field label="Equipe"
        ><b-select v-model="equipeId" expanded placeholder="Selecione uma equipe" @input="carregarDados"
          ><option v-for="x in equipes" :key="x.id" :value="x.id">{{ x.nome }} · {{ x.area }}</option></b-select
        ></b-field
      >
      <p v-if="!equipes.length" class="rh-muted">Você ainda não tem uma equipe disponível.</p>
    </section>
    <b-message
      v-if="equipeId && (reunioesLembrete.length || pdisAtrasados.length)"
      type="is-warning"
      aria-close-label="Fechar"
      >{{ reunioesLembrete.length }} próximo(s) 1:1 nos próximos 7 dias ou em atraso · {{ pdisAtrasados.length }} PDI(s)
      com prazo vencido.
      <button class="button is-small is-light" @click="aba = reunioesLembrete.length ? 'reunioes' : 'pdis'">
        Ver registros
      </button></b-message
    >
    <template v-if="equipeId || podeGerir">
      <nav class="tabs is-boxed rh-tabs" aria-label="Desenvolvimento">
        <ul role="tablist">
          <li v-if="podeGerir" :class="{ 'is-active': aba === 'avaliacoes' }">
            <button type="button" role="tab" :aria-selected="aba === 'avaliacoes'" @click="aba = 'avaliacoes'">
              Avaliações
            </button>
          </li>
          <li :class="{ 'is-active': aba === 'pdis' }">
            <button type="button" role="tab" :aria-selected="aba === 'pdis'" @click="aba = 'pdis'">PDI</button>
          </li>
          <li :class="{ 'is-active': aba === 'reunioes' }">
            <button type="button" role="tab" :aria-selected="aba === 'reunioes'" @click="aba = 'reunioes'">1:1</button>
          </li>
          <li :class="{ 'is-active': aba === 'metas' }">
            <button type="button" role="tab" :aria-selected="aba === 'metas'" @click="aba = 'metas'">Metas</button>
          </li>
          <li>
            <button type="button" @click="irParaCursos('ead-meus-cursos')">Treinamentos/Cursos</button>
          </li>
        </ul>
      </nav>
      <section class="rh-card">
        <div class="rh-card-head">
          <div>
            <p class="rh-kicker">{{ subtitulo }}</p>
            <h2>{{ titulo }}</h2>
          </div>
          <b-button v-if="podeGerir" type="is-primary" icon-left="plus" @click="novo">{{ botaoNovo }}</b-button>
        </div>
        <p class="rh-muted">{{ descricao }}</p>
        <b-field v-if="podeGerir && aba !== 'metas'" label=""
          ><b-select v-model="filtroColaboradorId"
            ><option :value="null">Todos da equipe</option>
            <option v-for="x in funcionarios" :key="x.id" :value="x.id">{{ x.nome }}</option></b-select
          ></b-field
        >
        <b-table
          :key="aba"
          :data="linhas"
          :loading="loading"
          :detailed="aba === 'avaliacoes' || aba === 'reunioes'"
          :show-detail-icon="aba === 'avaliacoes' || aba === 'reunioes'"
          detail-key="id"
          paginated
          :per-page="10"
          hoverable
          mobile-cards
        >
          <b-table-column v-if="aba !== 'metas'" v-slot="p" field="colaborador" label="Colaborador" sortable>{{
            p.row.colaborador
          }}</b-table-column>
          <b-table-column v-if="aba === 'avaliacoes'" v-slot="p" field="data" label="Data" sortable>{{
            dataCurta(p.row.data)
          }}</b-table-column>
          <b-table-column v-if="aba === 'avaliacoes'" v-slot="p" field="nivelHabilidade" label="Habilidade">{{
            p.row.nivelHabilidade || '—'
          }}</b-table-column>
          <b-table-column v-if="aba === 'pdis'" v-slot="p" field="objetivo" label="Objetivo" sortable>{{
            p.row.objetivo
          }}</b-table-column>
          <b-table-column v-if="aba === 'pdis'" v-slot="p" field="prazo" label="Prazo" sortable>{{
            dataCurta(p.row.prazo)
          }}</b-table-column>
          <b-table-column v-if="aba === 'pdis'" v-slot="p" field="dimensaoDiagnostico" label="Origem 9D">{{
            p.row.dimensaoDiagnostico || '—'
          }}</b-table-column>
          <b-table-column v-if="aba === 'pdis' || aba === 'reunioes'" v-slot="p" field="status" label="Status"
            ><b-tag :type="tipoStatus(p.row.status)">{{ textoStatus(p.row.status) }}</b-tag></b-table-column
          >
          <b-table-column v-if="aba === 'reunioes'" v-slot="p" field="data" label="Data" sortable>{{
            dataHora(p.row.data)
          }}</b-table-column>
          <b-table-column v-if="aba === 'reunioes'" v-slot="p" field="proximaData" label="Próximo encontro">{{
            dataHora(p.row.proximaData)
          }}</b-table-column>
          <b-table-column v-if="aba === 'metas'" v-slot="p" field="titulo" label="Meta" sortable
            ><strong>{{ p.row.titulo }}</strong
            ><small class="rh-small">{{ p.row.indicador }}</small></b-table-column
          >
          <b-table-column v-if="aba === 'metas'" v-slot="p" field="colaborador" label="Colaborador" sortable>{{ p.row.colaborador || '—' }}</b-table-column>
          <b-table-column v-if="aba === 'metas'" v-slot="p" field="unidadeMedida" label="Unidade de medida" sortable
            ><b-tag type="is-light">{{ p.row.unidadeMedida || '—' }}</b-tag></b-table-column
          >
          <b-table-column v-if="aba === 'metas'" v-slot="p" field="fimEm" label="Até">{{
            dataCurta(p.row.fimEm)
          }}</b-table-column>
          <b-table-column v-if="aba === 'metas'" v-slot="p" field="realizado" label="Progresso"
            ><progress
              class="progress is-info"
              :value="Math.min(100, Math.max(0, (p.row.realizado / p.row.alvo) * 100))"
              max="100"
            ></progress
            ><small>{{ p.row.realizado }} / {{ p.row.alvo }}</small></b-table-column
          >
          <b-table-column v-slot="p" label="Ações" width="160"
            ><b-button
              size="is-small"
              type="is-light"
              icon-left="eye-outline"
              :aria-label="'Ver detalhe de ' + (p.row.colaborador || p.row.titulo)"
              @click="abrir(p.row)"
              >{{ podeGerir ? 'Editar' : 'Ver' }}</b-button
            ><b-button
              v-if="podeGerir"
              size="is-small"
              type="is-danger"
              icon-left="delete-outline"
              :loading="excluindoId === p.row.id"
              :disabled="excluindoId !== null"
              :aria-label="'Excluir registro de ' + (p.row.colaborador || p.row.titulo)"
              @click.stop="confirmarExclusao(p.row)"
            ></b-button
          ></b-table-column>
          <template v-if="aba === 'avaliacoes' || aba === 'reunioes'" #detail="p">
            <div class="rh-registro-detalhe">
              <template v-if="aba === 'avaliacoes'">
                <div>
                  <strong>Checklist / itens avaliados</strong>
                  <p>{{ p.row.checklist || 'Não informado.' }}</p>
                </div>
                <div>
                  <strong>Pontos fortes</strong>
                  <p>{{ p.row.pontosFortes || 'Não informados.' }}</p>
                </div>
                <div>
                  <strong>Pontos a desenvolver</strong>
                  <p>{{ p.row.pontosDesenvolver || 'Não informados.' }}</p>
                </div>
                <div>
                  <strong>Notas / observações</strong>
                  <p>{{ p.row.notas || 'Nenhuma observação registrada.' }}</p>
                </div>
              </template>
              <template v-else>
                <div>
                  <strong>Pauta</strong>
                  <p>{{ p.row.pauta || 'Não informada.' }}</p>
                </div>
                <div>
                  <strong>Combinados</strong>
                  <p>{{ p.row.combinados || 'Nenhum combinado registrado.' }}</p>
                </div>
              </template>
            </div>
          </template>
          <template #empty><div class="rh-empty">Ainda não há registros nesta seção.</div></template>
        </b-table>
      </section>
    </template>

    <b-modal :active.sync="modal" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <ValidationObserver v-slot="{ handleSubmit }" slim
        ><form class="modal-card" @submit.prevent="handleSubmit(salvar)">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ formulario.id ? 'Detalhe' : 'Novo registro' }} · {{ titulo }}</p>
          </header>
          <section class="modal-card-body">
            <b-field v-if="aba !== 'metas'" label="Colaborador"
              ><b-select
                v-model="formulario.colaboradorId"
                expanded
                :disabled="!podeGerir"
                placeholder="Selecione uma pessoa"
                ><option v-for="x in funcionarios" :key="x.id" :value="x.id">{{ x.nome }}</option></b-select
              ></b-field
            >

            <template v-if="aba === 'avaliacoes'"
              ><b-field label="Data"
                ><input v-model="formulario.data" class="input" type="date" :disabled="!podeGerir" /></b-field
              ><b-field label="Checklist / itens avaliados"
                ><b-input
                  v-model.trim="formulario.checklist"
                  type="textarea"
                  :disabled="!podeGerir"
                  placeholder="Registre os itens observados"
                ></b-input></b-field
              ><b-field label="Pontos fortes"
                ><b-input
                  v-model.trim="formulario.pontosFortes"
                  type="textarea"
                  :disabled="!podeGerir"
                ></b-input></b-field
              ><b-field label="Pontos a desenvolver"
                ><b-input
                  v-model.trim="formulario.pontosDesenvolver"
                  type="textarea"
                  :disabled="!podeGerir"
                ></b-input></b-field
              ><b-field label="Nível de habilidades"
                ><b-input
                  v-model.trim="formulario.nivelHabilidade"
                  maxlength="80"
                  :disabled="!podeGerir"
                ></b-input></b-field
              ><b-field label="Notas / observações"
                ><b-input v-model.trim="formulario.notas" type="textarea" :disabled="!podeGerir"></b-input></b-field
            ></template>

            <template v-else-if="aba === 'pdis'"
              ><ValidationProvider v-slot="{ errors }" name="Objetivo" rules="required|max:500"
                ><b-field
                  label="Objetivo de desenvolvimento"
                  :type="errors.length ? 'is-danger' : ''"
                  :message="errors[0]"
                  ><b-input
                    v-model.trim="formulario.objetivo"
                    maxlength="500"
                    :disabled="!podeGerir"
                  ></b-input></b-field></ValidationProvider
              ><b-field label="Ações"
                ><b-input
                  v-model.trim="formulario.acoes"
                  type="textarea"
                  :disabled="!podeGerir"
                  placeholder="Descreva as ações práticas"
                ></b-input></b-field
              ><b-field label="Avaliação de origem"
                ><b-select v-model="formulario.avaliacaoId" expanded :disabled="!podeGerir"
                  ><option :value="null">Sem avaliação vinculada</option>
                  <option
                    v-for="x in avaliacoes.filter((a) => a.colaboradorId === formulario.colaboradorId)"
                    :key="x.id"
                    :value="x.id"
                  >
                    {{ dataCurta(x.data) }} · {{ x.colaborador }}
                  </option></b-select
                ></b-field
              ><b-field label="Ciclo de diagnóstico"
                ><b-select
                  v-model="formulario.cicloDiagnosticoId"
                  expanded
                  :disabled="!podeGerir"
                  @input="formulario.dimensaoDiagnosticoId = null"
                  ><option :value="null">Sem diagnóstico vinculado</option>
                  <option v-for="x in ciclosDiagnostico" :key="x.id" :value="x.id">
                    {{ x.nome }} · {{ dataCurta(x.inicioEm) }}
                  </option></b-select
                ></b-field
              ><b-field v-if="formulario.cicloDiagnosticoId" label="Dimensão de origem"
                ><b-select v-model="formulario.dimensaoDiagnosticoId" expanded :disabled="!podeGerir"
                  ><option :value="null">Selecione a dimensão</option>
                  <option v-for="x in dimensoesDoCiclo" :key="x.id" :value="x.id">
                    {{ x.nome }} · {{ Number(x.media).toFixed(2) }}
                  </option></b-select
                ></b-field
              >
              <p v-if="formulario.cicloDiagnosticoId" class="rh-muted">
                Referência agregada da equipe. O diagnóstico não identifica a resposta do colaborador.
              </p>
              <b-field label="Prazo"
                ><input v-model="formulario.prazo" type="date" class="input" :disabled="!podeGerir" required /></b-field
              ><b-field label="Status"
                ><b-select v-model="formulario.status" expanded :disabled="!podeGerir"
                  ><option value="planejado">Planejado</option>
                  <option value="em_andamento">Em andamento</option>
                  <option value="concluido">Concluído</option>
                  <option value="cancelado">Cancelado</option></b-select
                ></b-field
              ></template
            >

            <template v-else-if="aba === 'reunioes'"
              ><b-field label="Data e hora"
                ><input
                  v-model="formulario.data"
                  type="datetime-local"
                  class="input"
                  :disabled="!podeGerir"
                  required /></b-field
              ><b-field label="Pauta"
                ><b-input v-model.trim="formulario.pauta" type="textarea" :disabled="!podeGerir"></b-input></b-field
              ><b-field label="Combinados"
                ><b-input
                  v-model.trim="formulario.combinados"
                  type="textarea"
                  :disabled="!podeGerir"
                ></b-input></b-field
              ><b-field label="Próximo encontro"
                ><input
                  v-model="formulario.proximaData"
                  type="datetime-local"
                  class="input"
                  :disabled="!podeGerir" /></b-field
              ><b-field label="Status"
                ><b-select v-model="formulario.status" expanded :disabled="!podeGerir"
                  ><option value="agendada">Agendada</option>
                  <option value="realizada">Realizada</option>
                  <option value="cancelada">Cancelada</option></b-select
                ></b-field
              ></template
            >

            <template v-else
              ><ValidationProvider v-slot="{ errors }" name="Colaborador" rules="required">
                <b-field label="Colaborador da meta" :type="errors.length ? 'is-danger' : ''" :message="errors[0]">
                  <b-select v-model="formulario.colaboradorId" expanded :disabled="!podeGerir"><option :value="null">Selecione</option>
                    <option v-for="p in funcionarios" :key="p.id" :value="p.id">{{ p.nome }}</option></b-select>
                </b-field>
              </ValidationProvider><ValidationProvider v-slot="{ errors }" name="Título" rules="required|max:200"
                ><b-field label="Título da meta" :type="errors.length ? 'is-danger' : ''" :message="errors[0]"
                  ><b-input
                    v-model.trim="formulario.titulo"
                    maxlength="200"
                    :disabled="!podeGerir"
                  ></b-input></b-field></ValidationProvider
              ><ValidationProvider v-slot="{ errors }" name="Indicador" rules="required|max:200"
                ><b-field label="Indicador" :type="errors.length ? 'is-danger' : ''" :message="errors[0]"
                  ><b-input
                    v-model.trim="formulario.indicador"
                    maxlength="200"
                    :disabled="!podeGerir"
                  ></b-input></b-field
              ></ValidationProvider>
              <div class="rh-two">
                <b-field label="Alvo"
                  ><b-input
                    v-model.number="formulario.alvo"
                    type="number"
                    step="0.01"
                    min="0.01"
                    :disabled="!podeGerir"
                  ></b-input></b-field
                ><b-field label="Realizado"
                  ><b-input
                    v-model.number="formulario.realizado"
                    type="number"
                    step="0.01"
                    min="0"
                    :disabled="!podeGerir"
                  ></b-input
                ></b-field>
              </div>
              <b-field label="Unidade de medida"
                ><b-input
                  v-model.trim="formulario.unidadeMedida"
                  maxlength="50"
                  :disabled="!podeGerir"
                  placeholder="%, R$, unidades..."
                ></b-input
              ></b-field>
              <div class="rh-two">
                <b-field label="Início"
                  ><input
                    v-model="formulario.inicioEm"
                    type="date"
                    class="input"
                    :disabled="!podeGerir"
                    required /></b-field
                ><b-field label="Término"
                  ><input v-model="formulario.fimEm" type="date" class="input" :disabled="!podeGerir" required
                /></b-field></div
            ></template>
          </section>
          <footer class="modal-card-foot">
            <b-button @click="modal = false">Fechar</b-button
            ><b-button v-if="podeGerir" native-type="submit" type="is-primary" :loading="salvando">Salvar</b-button>
          </footer>
        </form></ValidationObserver
      >
    </b-modal>
  </main>
</template>

<script>
import http from '@/http'
import RhCabecalho from '@/components/rh_cabecalho.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'RhDesenvolvimento',
  components: { RhCabecalho },
  data() {
    return {
      empresas: [],
      unidadeId: null,
      equipes: [],
      equipeId: null,
      funcionarios: [],
      avaliacoes: [],
      pdis: [],
      reunioes: [],
      metas: [],
      meusCursos: [],
      ciclosDiagnostico: [],
      filtroColaboradorId: null,
      aba: 'pdis',
      formulario: {},
      modal: false,
      loading: false,
      salvando: false,
      excluindoId: null,
      erro: '',
    }
  },
  computed: {
    ...mapGetters(['isInRole']),
    podeGerir() {
      return this.isInRole('rh-diretoria') || this.isInRole('rh-lider')
    },
    dimensoesDoCiclo() {
      const ciclo = this.ciclosDiagnostico.find((x) => x.id === this.formulario.cicloDiagnosticoId)
      return ciclo ? ciclo.dimensoes : []
    },
    reunioesLembrete() {
      const limite = Date.now() + 7 * 24 * 60 * 60 * 1000
      const recentes = {}
      this.reunioes.forEach((x) => {
        if (!recentes[x.colaboradorId] || new Date(x.data) > new Date(recentes[x.colaboradorId].data))
          recentes[x.colaboradorId] = x
      })
      return Object.values(recentes).filter(
        (x) => x.status !== 'cancelada' && x.proximaData && new Date(x.proximaData).getTime() <= limite
      )
    },
    pdisAtrasados() {
      return this.pdis.filter(
        (x) => x.status !== 'concluido' && x.status !== 'cancelado' && new Date(x.prazo).getTime() < Date.now()
      )
    },
    linhas() {
      const itens = this[this.aba] || []
      return this.aba !== 'metas' && this.filtroColaboradorId
        ? itens.filter((x) => x.colaboradorId === this.filtroColaboradorId)
        : itens
    },
    titulo() {
      return {
        avaliacoes: 'Avaliações individuais',
        pdis: 'Planos de desenvolvimento',
        reunioes: 'Reuniões 1:1',
        metas: 'Metas da equipe',
      }[this.aba]
    },
    subtitulo() {
      return { avaliacoes: 'DESEMPENHO', pdis: 'PLANO INDIVIDUAL', reunioes: 'CONVERSAS', metas: 'INDICADORES' }[
        this.aba
      ]
    },
    botaoNovo() {
      return { avaliacoes: 'Nova avaliação', pdis: 'Novo PDI', reunioes: 'Nova reunião', metas: 'Nova meta' }[this.aba]
    },
    descricao() {
      return {
        avaliacoes: '',
        pdis: '',
        reunioes: '',
        metas: '',
      }[this.aba]
    },
  },
  created() {
    this.aba = this.podeGerir ? 'avaliacoes' : 'pdis'
    this.iniciar()
    this.carregarMeusCursos()
  },
  methods: {
    duracaoCurso(valor) {
      const minutos = Number(valor) || 0
      const horas = Math.floor(minutos / 60)
      const restante = minutos % 60
      return horas ? `${horas}h${restante ? ` ${restante}min` : ''}` : `${restante}min`
    },
    statusCurso(status) {
      return { NAO_INICIADO: 'Não iniciado', EM_ANDAMENTO: 'Em andamento', CONCLUIDO: 'Concluído', REPROVADO: 'Reprovado' }[status] || status
    },
    async carregarMeusCursos() {
      try {
        const resposta = await http.get('/api/ead-aprendizagem/meus-cursos')
        this.meusCursos = (resposta.data || []).filter((x) => x.status !== 'BLOQUEADO')
      } catch (e) {
        this.meusCursos = []
        this.falha(e)
      }
    },
    irParaCursos(rota) {
      if (this.unidadeId) this.$store.commit('SET_UNIDADE', this.unidadeId)
      this.$router.push({ name: rota })
    },
    selecionarEmpresa(id) {
      this.unidadeId = id
      this.carregarEmpresa()
    },
    falha(e) {
      this.erro = e && e.data && e.data.erro ? e.data.erro : 'Não foi possível concluir a operação. Tente novamente.'
    },
    dataCurta(v) {
      return v ? new Date(v).toLocaleDateString('pt-BR') : '—'
    },
    dataHora(v) {
      if (!v) return '—'
      const data = new Date(v)
      return `${data.toLocaleDateString('pt-BR')} às ${data.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      })}`
    },
    textoStatus(v) {
      return v === 'em_andamento'
        ? 'Em andamento'
        : {
            planejado: 'Planejado',
            concluido: 'Concluído',
            cancelado: 'Cancelado',
            agendada: 'Agendada',
            realizada: 'Realizada',
            cancelada: 'Cancelada',
          }[v] || v
    },
    tipoStatus(v) {
      return v === 'concluido' || v === 'realizada'
        ? 'is-success'
        : v === 'cancelado' || v === 'cancelada'
        ? 'is-light'
        : 'is-info'
    },
    localData(v, hora) {
      if (!v) return ''
      const d = new Date(v)
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}${
        hora ? `T${pad(d.getHours())}:${pad(d.getMinutes())}` : ''
      }`
    },
    async iniciar() {
      this.loading = true
      try {
        this.empresas = (await http.get('/api/rh/estrutura/empresas')).data || []
        const atual = Number(this.$store.state.unidadeId)
        this.unidadeId = this.empresas.some((x) => x.id === atual)
          ? atual
          : (this.empresas[0] && this.empresas[0].id) || null
        if (this.unidadeId) await this.carregarEmpresa()
      } catch (e) {
        this.falha(e)
      } finally {
        this.loading = false
      }
    },
    async carregarEmpresa() {
      this.equipes = []
      this.equipeId = null
      this.limparListas()
      if (!this.unidadeId) return
      try {
        this.equipes =
          (await http.get('/api/rh/estrutura/equipes', { params: { unidadeId: this.unidadeId } })).data || []
        this.equipeId = (this.equipes[0] && this.equipes[0].id) || null
        if (this.equipeId) await this.carregarDados()
      } catch (e) {
        this.falha(e)
      }
    },
    limparListas() {
      this.avaliacoes = []
      this.pdis = []
      this.reunioes = []
      this.metas = []
      this.ciclosDiagnostico = []
    },
    async carregarDados() {
      this.limparListas()
      this.funcionarios = []
      this.filtroColaboradorId = null
      if (!this.equipeId) return
      this.loading = true
      try {
        const params = { unidadeId: this.unidadeId, equipeId: this.equipeId }
        const endpoints = this.podeGerir ? ['avaliacoes', 'pdis', 'reunioes', 'metas'] : ['pdis', 'reunioes', 'metas']
        const respostas = await Promise.all(endpoints.map((x) => http.get(`/api/rh/desenvolvimento/${x}`, { params })))
        endpoints.forEach((x, i) => {
          this[x] = respostas[i].data || []
        })
        if (this.podeGerir) {
          const [membros, ciclos] = await Promise.all([
            http.get('/api/rh/estrutura/membros', { params }),
            http.get('/api/rh/diagnostico/evolucao', { params }),
          ])
          this.funcionarios = membros.data || []
          this.ciclosDiagnostico = ciclos.data || []
        }
      } catch (e) {
        this.falha(e)
      } finally {
        this.loading = false
      }
    },
    novo() {
      const base = { id: null, colaboradorId: null }
      this.formulario =
        this.aba === 'avaliacoes'
          ? {
              ...base,
              data: this.localData(new Date()),
              checklist: '',
              pontosFortes: '',
              pontosDesenvolver: '',
              nivelHabilidade: '',
              notas: '',
            }
          : this.aba === 'pdis'
          ? {
              ...base,
              avaliacaoId: null,
              cicloDiagnosticoId: null,
              dimensaoDiagnosticoId: null,
              objetivo: '',
              acoes: '',
              prazo: '',
              status: 'planejado',
            }
          : this.aba === 'reunioes'
          ? { ...base, data: '', proximaData: '', pauta: '', combinados: '', status: 'agendada' }
          : {
              id: null,
              colaboradorId: null,
              titulo: '',
              indicador: '',
              alvo: null,
              realizado: 0,
              unidadeMedida: '',
              inicioEm: '',
              fimEm: '',
            }
      this.modal = true
    },
    abrir(item) {
      this.formulario = { ...item }
      ;['data', 'proximaData', 'prazo', 'inicioEm', 'fimEm'].forEach((k) => {
        if (this.formulario[k])
          this.formulario[k] = this.localData(
            this.formulario[k],
            (k === 'data' && this.aba === 'reunioes') || k === 'proximaData'
          )
      })
      this.modal = true
    },
    confirmarExclusao(item) {
      const tipo = this.aba
      this.$buefy.dialog.confirm({
        title: 'Excluir registro',
        message: 'O registro e seu evento na Agenda serão excluídos permanentemente. Confirmar?',
        confirmText: 'Excluir',
        cancelText: 'Cancelar',
        type: 'is-danger',
        onConfirm: async () => {
          if (this.excluindoId !== null) return
          this.excluindoId = item.id
          try {
            await http.delete(`/api/rh/desenvolvimento/${tipo}/${item.id}`, {
              params: { unidadeId: this.unidadeId, equipeId: this.equipeId },
            })
            await this.carregarDados()
            this.$buefy.toast.open({ message: 'Registro excluído.', type: 'is-success' })
          } catch (e) {
            this.falha(e)
          } finally {
            this.excluindoId = null
          }
        },
      })
    },
    async salvar() {
      if (!this.podeGerir) return
      this.salvando = true
      try {
        const p = { ...this.formulario, unidadeId: this.unidadeId, equipeId: this.equipeId }
        ;['data', 'proximaData', 'prazo', 'inicioEm', 'fimEm'].forEach((k) => {
          if (p[k]) {
            const apenasData = k === 'prazo' || k === 'inicioEm' || k === 'fimEm' || (k === 'data' && this.aba === 'avaliacoes')
            p[k] = new Date(apenasData ? `${p[k]}T12:00:00` : p[k]).toISOString()
          }
        })
        await http.post(`/api/rh/desenvolvimento/${this.aba}`, p)
        this.modal = false
        await this.carregarDados()
        this.$buefy.toast.open({ message: 'Registro salvo.', type: 'is-success' })
      } catch (e) {
        this.falha(e)
      } finally {
        this.salvando = false
      }
    },
  },
}
</script>

<style scoped>
.rh-development {
  --navy: #0b1a3e;
  --blue: #007bff;
  --teal: #0e8fa8;
  background: #f4f3f0;
  min-height: 100vh;
  padding: 0 28px 48px;
  border-radius: 18px;
  color: #1c1d24;
  font-family: Montserrat, Arial, sans-serif;
}
.rh-muted {
  color: #667085;
  font-size: 13px;
}
.rh-kicker {
  letter-spacing: 0.15em;
  font-size: 11px;
  font-weight: 800;
  color: var(--teal);
  margin: 0;
}
.rh-card {
  background: #fff;
  border: 1px solid #e7e9ed;
  border-radius: 17px;
  padding: 24px;
  margin: 16px 0;
  box-shadow: 0 8px 20px rgba(11, 26, 62, 0.04);
}
.rh-team-select .field {
  max-width: 560px;
}
.rh-card h2 {
  font-size: 22px;
  color: var(--navy);
  font-weight: 800;
  margin: 5px 0;
}
.rh-card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.rh-learning-card { margin-top: 22px; border-top: 3px solid #2aa9a1; }
.rh-learning-card .rh-card-head { margin-bottom: 18px; }
.rh-learning-card .rh-card-head .rh-muted { margin-top: 4px; }
.rh-learning-card .tag + .tag { margin-left: 5px; }
.rh-tabs {
  margin-top: 22px;
  overflow-x: auto;
}
.rh-tabs li {
  flex: none;
}
.rh-tabs li button {
  align-items: center;
  background: transparent;
  border: 1px solid transparent;
  border-bottom-color: #dbdbdb;
  border-radius: 4px 4px 0 0;
  color: #4a4a4a;
  cursor: pointer;
  display: flex;
  font: 400 14px Montserrat, Arial, sans-serif;
  padding: 0.5em 0.9em;
  white-space: nowrap;
}
.rh-tabs li.is-active button {
  background: #fff;
  border-color: #dbdbdb;
  border-bottom-color: #fff;
  color: #005dc7;
}
.rh-tabs li button:hover {
  color: #005dc7;
}
.rh-tabs li button:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: -2px;
}
.rh-small {
  display: block;
  color: #667085;
  font-size: 11px;
}
.rh-registro-detalhe {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  padding: 12px 16px;
}
.rh-registro-detalhe strong {
  color: var(--navy);
  font-size: 13px;
}
.rh-registro-detalhe p {
  margin: 6px 0 0;
  color: #53627b;
  font-size: 13px;
  white-space: pre-line;
  overflow-wrap: anywhere;
}
.rh-empty {
  padding: 28px;
  text-align: center;
  color: #667085;
}
.rh-two {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.progress {
  min-width: 110px;
  margin-bottom: 2px !important;
}
@media (max-width: 560px) {
  .rh-development {
    padding: 0 14px 30px;
  }
  .rh-card {
    padding: 18px;
  }
  .rh-learning-card .rh-card-head { align-items: flex-start; flex-direction: column; }
  .rh-two {
    grid-template-columns: 1fr;
  }
  .rh-registro-detalhe {
    grid-template-columns: 1fr;
    gap: 14px;
    padding: 10px 4px;
  }
}
</style>
